
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { CURRENCIES } from '../constants';

interface CurrencyContextType {
  currencyCode: string;
  setCurrencyCode: (code: string) => void;
  currencySymbol: string;
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(undefined);

export const CurrencyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currencyCode, setCurrencyCode] = useState('INR');

  const currencySymbol = CURRENCIES.find(c => c.code === currencyCode)?.symbol || '₹';

  return (
    <CurrencyContext.Provider value={{ currencyCode, setCurrencyCode, currencySymbol }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};
